/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpDiskSnapshotProperties {
  /**
  * The ID of the disk
  */
  'diskId': string;
  /**
  * The name of the disk
  */
  'diskName': string;
  /**
  * The type of the disk
  */
  'diskType': string;
  /**
  * The size of the disk in bytes
  */
  'diskSizeBytes': number;
  /**
  * The tags associated with the resource
  */
  'tags'?: { [key: string]: string; };
  /**
  * Disk IOPS.
  */
  'iops'?: number;
  /**
  * Disk throughput.
  */
  'throughput'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "diskId",
      "baseName": "diskId",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskName",
      "baseName": "diskName",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskType",
      "baseName": "diskType",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskSizeBytes",
      "baseName": "diskSizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "iops",
      "baseName": "iops",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "throughput",
      "baseName": "throughput",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return GcpDiskSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

